import PlaceholderPage from "../components/PlaceholderPage";

function ResourcesPage() {
  return (
    <PlaceholderPage
      title="Resources"
      description="Blog articles, Colorbond colours, brochures and FAQs are coming soon."
      path="/resources"
    />
  );
}

export default ResourcesPage;
